<script lang="ts" setup>
import type { CascaderComponentProps, CascaderInstance, CascaderValue, } from "element-plus"
import { cascaderEmits, } from "element-plus"

const props = withDefaults(defineProps<Props>(), {
  options: () => [],
  props: () => ({}),
  disabled: undefined,
  clearIcon: undefined,
  filterMethod: (node, keyword,) => {
    return node.text.toLowerCase().includes(keyword.toLowerCase(),)
  },
  separator: " / ",
  showAllLevels: true,
  maxCollapseTags: 1,
  debounce: 300,
  beforeFilter: () => true,
  placement: "bottom-start",
  fallbackPlacements: () => [
    "bottom-start",
    "bottom",
    "top-start",
    "top",
    "right",
    "left",
  ],
  teleported: true,
  effect: "light",
  tagType: "info",
  tagEffect: "light",
  validateEvent: true,
  persistent: true,
  showCheckedStrategy: "child",
  showPrefix: true,
  popperStyle: undefined,
  valueOnClear: undefined,
},)

const emits = defineEmits(cascaderEmits,)

type Props = Omit<CascaderComponentProps, "modelValue">

const modelValue = defineModel<CascaderValue | null>()

const cascaderRef = ref<CascaderInstance>()

defineExpose({
  cascaderRef,
},)
</script>

<template>
  <ElCascader
    ref="cascaderRef"
    v-model="modelValue"
    class="w-full"
    v-bind="props"
    @blur="emits('blur', $event)"
    @change="emits('change', $event)"
    @clear="emits('clear')"
    @expand-change="emits('expandChange', $event)"
    @focus="emits('focus', $event)"
    @remove-tag="emits('removeTag', $event)"
    @visible-change="emits('visibleChange', $event)"
  />
</template>

<style lang="scss" scoped>
</style>
